import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
var NewLine = /*#__PURE__*/function (_Component) {
  function NewLine() {
    var _this;
    _classCallCheck(this, NewLine);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, NewLine, [].concat(args));
    _defineProperty(_this, "renderLine", function (data) {
      var _this$props = _this.props,
        showAmount = _this$props.showAmount,
        showLabel = _this$props.showLabel,
        showAllSteps = _this$props.showAllSteps,
        showPercentage = _this$props.showPercentage;
      var steps = [];
      var total = data.map(function (item) {
        return parseInt(item.amount, 10);
      }).reduce(function (prev, next) {
        return prev + next;
      });
      data.map(function (step) {
        var stepWidth = 0;
        if (total > 0) {
          stepWidth = parseInt(step.amount, 10) / total * 100 + '%';
        } else {
          stepWidth = 100 / data.length + '%';
        }
        steps.push({
          width: stepWidth,
          label: step.label ? step.label : '',
          color: step.color ? step.color : '#9E82EB',
          amount: step.amount
        });
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "bar-container"
      }, steps.map(function (step, i) {
        var style = showAllSteps && step.width == '0%' ? {
          padding: '0.2em 0.3em !important',
          backgroundColor: step.color
        } : {
          width: step.width,
          backgroundColor: step.color
        };
        return /*#__PURE__*/React.createElement("span", {
          key: i,
          className: "step",
          style: style
        }, showLabel ? step.label : null, showAmount ? " ".concat(step.amount) : null, showPercentage ? " ".concat(step.width, "%") : null);
      }));
    });
    return _this;
  }
  _inherits(NewLine, _Component);
  return _createClass(NewLine, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        data = _this$props2.data,
        datasets = _this$props2.datasets;
      if (datasets) {
        return /*#__PURE__*/React.createElement("div", {
          className: "graph line bar"
        }, datasets.map(function (data) {
          return _this2.renderLine(data);
        }));
      }
      if (data) {
        return /*#__PURE__*/React.createElement("div", {
          className: "graph line bar"
        }, this.renderLine(data));
      }
      return null;
    }
  }]);
}(Component);
_defineProperty(NewLine, "defaultProps", {
  showAmount: false,
  showLabel: false,
  showAllSteps: false
});
export default NewLine;